import React, { Children, cloneElement } from 'react';

interface StaggeredFadeProps {
  children: React.ReactNode;
  staggerDelay?: number;
  baseDelay?: number;
}

const StaggeredFade: React.FC<StaggeredFadeProps> = ({ 
  children,
  staggerDelay = 0.1,
  baseDelay = 0
}) => {
  return (
    <>
      {Children.map(children, (child, index) => {
        if (!React.isValidElement(child)) return child;
        
        return cloneElement(child, {
          style: {
            ...child.props.style,
            opacity: 0,
            animation: 'fade-in 0.5s ease-out forwards',
            animationDelay: `${baseDelay + (index * staggerDelay)}s`
          }
        });
      })}
    </>
  );
};

export default StaggeredFade;